import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const schema = z.object({
  track_id: z.coerce.string(),
  email: z.coerce.string().optional(),
})

export const existingAccountSearchSchema = zodValidator(schema)
export type ExistingAccountSearchSchema = z.infer<typeof schema>
